import {TextUtils} from "../../../shared/utils/text-utils";

export const points = [
  {
    img: './../../assets/images/illustrations/next-gen.svg',
    title: 'Next Generation Infrastructure',
    desc: 'Obtaining Google Cloud’s best servers & SSDs, <br class="db-hide-mobile" /> Nginx, FastCGI caching, LXD containers, and  <br class="db-hide-mobile" />  the up-to-date version of PHP 7.4.'
  },
  {
    img: './../../assets/images/illustrations/google-cloud.svg',
    title: 'Google Cloud Platform',
    desc: 'Ensuring a premium tier network, designed to  <br class="db-hide-mobile" />  minimize distance and hops, resulting in fast  <br class="db-hide-mobile" />  and secure transport of your website’s data'
  },
  {
    img: './../../assets/images/illustrations/management.svg',
    title: 'Automated Website Management',
    desc: 'Brining automated daily backup system,  <br class="db-hide-mobile" />  full automated security checkups, automated  <br class="db-hide-mobile" />  free SSL certificates in an intuitive dashboard'
  },
];
export const checklistItems = [
  {
    text: TextUtils.getText('text_page.caching'),
    tooltip: TextUtils.getText('text_tooltip.page.caching')
  },
  {
    text: TextUtils.getText('text_css.html.minify'),
    tooltip: TextUtils.getText('text_tooltip.css.html.minify')
  },
  {
    text: TextUtils.getText('text_gzip.compression'),
    tooltip: TextUtils.getText('text_tooltip.gzip.compression')
  },
  {
    text: TextUtils.getText('text_js.minification'),
    tooltip: TextUtils.getText('text_tooltip.js.minification')
  },
  {
    text: TextUtils.getText('text_db.optimization'),
    tooltip: TextUtils.getText('text_tooltip.db.optimization')
  },
  {
    text: TextUtils.getText('text_js.css.execution'),
    tooltip: TextUtils.getText('text_tooltip.js.css.execution')
  },
  {
    text: TextUtils.getText('text_userSummariesIoTitle'),
    tooltip: TextUtils.getText('text_tooltip.img.optimization')
  },
  {
    text: TextUtils.getText('text_dns.critical'),
    tooltip: TextUtils.getText('text_tooltip.dns.critical')
  },
  {
    text: TextUtils.getText('text_lazyload'),
    tooltip: TextUtils.getText('text_tooltip.lazyload')
  },
  {
    text: TextUtils.getText('text_font.swap'),
    tooltip: TextUtils.getText('text_tooltip.font.swap')
  },
  {
    text: TextUtils.getText('text_img.to.webp'),
    tooltip: TextUtils.getText('text_tooltip.img.to.webp')
  },
  {
    text: TextUtils.getText('text_iframe.video.lazyload'),
    tooltip: TextUtils.getText('text_tooltip.iframe.video.lazyload')
  },
  {
    text: TextUtils.getText('text_img.resizing'),
    tooltip: TextUtils.getText('text_tooltip.img.resizing')
  },
  {
    text: TextUtils.getText('text_woo.optimized'),
    tooltip: TextUtils.getText('text_tooltip.woo.optimized')
  }

];
export const pointsCreatedWebsite = [
  {
    img: './../../assets/images/illustrations/next-gen.svg',
    title: 'Next Generation Infrastructure',
    desc: 'Obtaining Google Cloud’s<br/> best servers & SSDs, Nginx, FastCGI<br class="db-copy-website-hide-mobile" /> caching, LXD containers, and the<br class="db-copy-website-hide-mobile" /> up-to-date version of PHP'
  },
  {
    img: './../../assets/images/illustrations/google-cloud.svg',
    title: 'Google<br/>Cloud Platform',
    desc: 'Ensuring a premium tier network,<br class="db-copy-website-hide-mobile" /> designed to minimize distance and<br class="db-copy-website-hide-mobile" />  hops, resulting in fast and secure<br class="db-copy-website-hide-mobile" /> transport of your website’s data'
  },
  {
    img: './../../assets/images/illustrations/management.svg',
    title: 'Automated Website Management',
    desc: 'Integrating automated<br/> real-time backup system,<br class="db-copy-website-hide-mobile" /> security checkups, free SSL certificates<br class="db-copy-website-hide-mobile" /> into an intuitive dashboard'
  },
];
export const whyNeedPoints = [
  {
    title: 'Increased<br/>Conversions',
    desc: 'Slow loading speed can drop conversions by 7%.'
  },
  {
    title: 'Reduced <br/>Traffic Loss',
    desc: '40% of people will leave the website if<br/> it takes more than 3 seconds to load.'
  },
  {
    title: 'Improved <br/>Rankings',
    desc: 'PageSpeed score directly impacts<br/>SEO rankings.'
  },
];
export const feedbacks = [
  {
    title: 'Fast and good hosting',
    desc: 'I have used many host platforms. <br class="db-hide-mobile"/> So I have to say 10web have a good dashboard, fast cache and good support.',
    author: 'by Terje Drivdal Sollie'
  },
  {
    title: 'Great experience with them!!!',
    desc: 'Great experience with them! For this price, you will get a premium Google Cloud based WordPress hosting, which is so much faster than those typical WordPress hosting providers. Customer service is really helpful and responsible!!!',
    author: 'by Robert Zhao'
  },
  {
    title: '10Web.io the fastest Manage...',
    desc: 'I tried the service for the past 14 days, the website speed ranking was satisfying and made me confenced to move our company WordPress website from our current hosting. All though they don\'t provide email hosting included in their...',
    author: 'by Abdulghani Alanaki'
  },
];
